export default __webpack_public_path__ + "static/media/land.6d80da84.svg";